import { useRef, useState } from 'react'

import {
  replaceStartZeroAndNotDigitToEmpty,
  insertCommaEveryThreeDigits,
} from '@src/utils'

export const useAmount = (initialValue = '') => {
  const [displayAmount, setAmount] = useState(initialValue)
  const amountInputRef = useRef<HTMLInputElement>(null)

  const handleChangeAmount = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = event.target.value
    const halfWidthDigit = replaceStartZeroAndNotDigitToEmpty(value)

    setAmount(insertCommaEveryThreeDigits(halfWidthDigit))
  }

  return {
    displayAmount,
    amountInputRef,
    handleChangeAmount,
    setAmount,
  }
}
